import React from "react";

export const AnswerTooltip = ({ content }: { content: string }) => {
  return (
    <>
      {content && (
        <div
          className="ch-alert ch-alert--info ch-fs--2"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </>
  );
};
